import axios from "axios";
import server_config from '../ServerConfiguration';

const fevir_node_server_address = server_config["fevir_node_server_address"];

const sortResourceElementsFunction = async (sourceJson = null, apiToken = null) => {
    if (!apiToken) {
        console.log("no apiToken");
        return null;
    }
    if (!sourceJson) {
        console.log("missing sourceJson");
        return null;
    }
    console.log("CALLING SERVER with sortresourceelementorder")
    return await axios({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            "functionid": "sortresourceelementorder",
            "apiToken": apiToken,
            'json': sourceJson
        },
    }).then((resp) => {
        if (resp?.data) {
            return resp.data;
            //resp.data is an object with success (boolean), sortedJson (object), non-spec-elements (array), message, error
        }
        console.log("NO RESPONSE from sortresourceelementorder call");
    }).catch((error) => { console.log(error); });
};

export default sortResourceElementsFunction;